import { DotLottieReact } from '@lottiefiles/dotlottie-react'
import * as React from 'react'

interface Props {
  src: string
  autoplay?: boolean
  loop?: boolean
  style?: React.CSSProperties
  className?: string
}

const Player = ({ ...props }: Props) => {
  return <DotLottieReact {...props} />
}

export default Player
